// Keep search consent consistent between the header modal and full results.
// Closed native details provide the default cover even before JavaScript runs.
const key = 'wb-search-include-rude';
let includeRude = false;
try { includeRude = sessionStorage.getItem(key) === '1'; } catch { /* In-page consent still works. */ }

function initialise(node) {
  if (!(node instanceof Element)) return;
  const covers = node.matches('[data-wb-rude-search]') ? [node] : [];
  covers.push(...node.querySelectorAll('[data-wb-rude-search]'));
  covers.forEach(cover => {cover.open = includeRude;});
  const controls = node.matches('[data-wb-search-preference]') ? [node] : [];
  controls.push(...node.querySelectorAll('[data-wb-search-preference]'));
  controls.forEach(control => {
    control.querySelector('input').checked = includeRude;
    control.querySelector('[data-wb-search-note]').textContent = includeRude
      ? 'Rude designs are included.'
      : 'Rude designs are covered. Reveal a card or include all rude designs.';
  });
}

initialise(document.documentElement);
document.addEventListener('change', event => {
  if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-wb-search-rude]')) return;
  includeRude = event.target.checked;
  try { sessionStorage.setItem(key, includeRude ? '1' : '0'); } catch { /* Optional persistence. */ }
  initialise(document.documentElement);
});

// Predictive search morphs its results; full search can append further pages.
// Apply consent only to new covers, preserving individually opened cards.
new MutationObserver(records => {
  for (const record of records) for (const node of record.addedNodes) initialise(node);
}).observe(document.body, {childList:true, subtree:true});
